import React, { Fragment } from 'react';
import { ChevronRight, Home } from 'lucide-react';
interface BreadcrumbItem {
  label: string;
  id?: string;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  onNavigate?: (id: string) => void;
}
export function Breadcrumbs({
  items,
  onNavigate
}: BreadcrumbsProps) {
  return <nav className="flex items-center text-sm text-gray-500 mb-6 whitespace-nowrap overflow-x-auto pb-2" data-id="element-131">
      <button onClick={() => onNavigate?.('overview')} className="flex items-center hover:text-[#0B5FA5] transition-colors" data-id="element-132">
        <Home className="w-4 h-4" data-id="element-133" />
      </button>

      {items.map((item, index) => <Fragment key={index} data-id="element-134">
          <ChevronRight className="w-4 h-4 mx-2 text-gray-400 flex-shrink-0" data-id="element-135" />
          {item.id && index < items.length - 1 ? <button onClick={() => onNavigate?.(item.id!)} className="hover:text-[#0B5FA5] transition-colors" data-id="element-136">
              {item.label}
            </button> : <span className={index === items.length - 1 ? 'text-gray-900 font-medium' : ''} data-id="element-137">
              {item.label}
            </span>}
        </Fragment>)}
    </nav>;
}